const groups = [
  {name:'Лица', emoji:'😀 😃 😄 😁 😆 😅 😂 🙂 🙃 😉 😊 😍 🥰 😘 😎 🤔 🤨 😐 😑 😶 🙄 😏 😣 😢 😭 😤 😡 🤯 😳 🥺 😴 🤗 🫡 🤩'},
  {name:'Жесты', emoji:'👍 👎 👏 🙌 🤝 🙏 💪 👋 🤞 ✌️ 👌 🫶 ✋ 🤷 🤦'},
  {name:'Символы', emoji:'❤️ 🧡 💛 💚 💙 💜 🖤 🤍 💔 💯 ✅ ❌ ❗ ❓ 🎉 ✨ 🔥 ⭐ 💡 📌'},
  {name:'Животные и предметы', emoji:'🐱 🐶 🐑 🐮 🐻 🐼 🦊 🐥 🌸 🌞 🌈 🌧️ 🍀 ☕ 🍕 🍰 🎂 🚀 🏠 💻 📱 📁 ✉️'},
];
/** Small native dialog; emoji are text and reuse normal message storage/rendering. */
export function showEmojiPicker(valid: () => boolean, insert: (emoji: string) => void, restore: () => void, stickers?: () => void): void {
  if (!valid() || document.querySelector('.emoji-picker-dialog')) return;
  const dialog = document.createElement('dialog'); dialog.className = 'emoji-picker-dialog'; dialog.setAttribute('aria-label','Эмодзи');
  const heading = document.createElement('div'); heading.className = 'emoji-picker-heading';
  const title = document.createElement('strong'); title.textContent = 'Эмодзи';
  const close = document.createElement('button'); close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label','Закрыть эмодзи');
  const search = document.createElement('input'); search.type = 'search'; search.placeholder = 'Поиск по категории'; search.setAttribute('aria-label','Поиск эмодзи');
  const body = document.createElement('div'); body.className = 'emoji-picker-body';
  const finish = (): void => { dialog.close(); dialog.remove(); if (valid()) restore(); };
  const render = (): void => {
    body.replaceChildren();
    for (const group of groups.filter(group => group.name.toLocaleLowerCase('ru').includes(search.value.trim().toLocaleLowerCase('ru')))) {
      const section = document.createElement('section'); const label = document.createElement('h4'); label.textContent = group.name;
      const grid = document.createElement('div'); grid.className = 'emoji-picker-grid';
      for (const emoji of group.emoji.split(' ')) {
        const button = document.createElement('button'); button.type = 'button'; button.textContent = emoji; button.setAttribute('aria-label',emoji);
        button.addEventListener('click', () => { finish(); if (valid()) insert(emoji); }); grid.append(button);
      }
      section.append(label,grid); body.append(section);
    }
    if (!body.childNodes.length) { const empty=document.createElement('p'); empty.textContent='Ничего не найдено'; body.append(empty); }
  };
  close.addEventListener('click', finish); dialog.addEventListener('cancel', event => {event.preventDefault();finish();});
  search.addEventListener('input', render); heading.append(title);
  if(stickers){const tab=document.createElement('button');tab.type='button';tab.textContent='Стикеры';tab.setAttribute('aria-label','Стикеры');tab.className='sticker-tab';tab.addEventListener('click',()=>{finish();stickers();});heading.append(tab);}
  heading.append(close); dialog.append(heading,search,body); document.body.append(dialog);
  render(); dialog.showModal(); search.focus();
}
